import React, { ErrorInfo } from "react";
import { logger } from "@utils/logger/logger";

type Props = {
	componentName: string;
	children: React.ReactNode;
};
export default class ErrorBoundaryWithPropagation extends React.Component<Props> {
	location: string;
	constructor(props: Props) {
		super(props);
		this.location = props.componentName;
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		logger.logError(error, { extra: { gp_location: this.location } });
		console.error("Error ", error, "\nStackTrace " + info);

		throw error;
	}

	render() {
		return this.props.children;
	}
}
